import { hideScroll, restoreScroll } from './_helpers.js'

const filters = document.querySelector('.filters')
const filtersBtn = document.querySelector('.filters-btn')
const filtersCloseBtn = document.querySelector('.filters-close-btn')
const mobileNavBtn = document.querySelector('.toggle-nav-btn')
const mobileNav = document.querySelector('.categories__container')
const mobileNavOverlay = document.querySelector('.mobile-nav-overlay')
const overlay = document.querySelector('.overlay')

if (filters && filtersBtn) {
    filtersBtn.addEventListener('click', function(e) {
        e.preventDefault()

        mobileNavOverlay.style.display = 'none'
        mobileNav.classList.remove('show-mobile-nav')
        mobileNavBtn.classList.remove('toggle')
        overlay.classList.add('show-overlay')
        filters.classList.add('show-filters')
        hideScroll()
    })

    overlay.addEventListener('click', function(e) {
        filters.classList.remove('show-filters')
        overlay.classList.remove('show-overlay')
        restoreScroll()
    })

    filtersCloseBtn.addEventListener('click', function(e) {
        e.preventDefault()
        filters.classList.remove('show-filters')
        overlay.classList.remove('show-overlay')
        restoreScroll()
    })
}

$(".cbx").change(function() {
  $(".filter-form").submit()
})

$(".sortby-select").change(function(){
  $("[name=sorting]").val($(this).val())
  $(".filter-form").submit()
})
